import useStateManager from 'components/hooks/useStateManager';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resource_types } from 'store/extraResource/constants';
import { updateUI } from 'store/UI/actions';
import { useUI } from 'store/UI/selectors';
import BalconPreview from './types/balconPreview';
import ResourcePreview from './types/resource';
import StoryPreview from './types/storyPreview';
import ApPreview from './types/apPreview';

const ShowBookPreviewExtensionActivity = ({ getRef }) => {
  const containerRef = getRef();
  const [states, updateState] = useStateManager({
    styles: { width: 0, height: 0 },
  });
  const dispatch = useDispatch();
  const { extensionActivity = {} } = useUI();
  const { open = false, config = {} } = extensionActivity;
  const { resource, balcon, conectándome, comunidad, informate, story, AP } = resource_types;

  useEffect(() => {
    function updateStyle() {
      if (containerRef) {
        const { width, height } = containerRef.getBoundingClientRect();
        updateState({ styles: { height, width } });
      }
    }

    updateStyle();
    window.addEventListener('resize', updateStyle);

    return () => {
      window.removeEventListener('resize', updateStyle);
    };
  }, [open]);

  const handleClose = async () => {
    await dispatch(updateUI({ extensionActivity: {} }));
  };

  return (
    <div className="shwPreviewCstm setIndexUprCstm">
    <React.Fragment key={extensionActivity?.id}>
      {(() => {
        switch (extensionActivity?.resource_type) {
          case resource:
            return (
              <>
                {open && (
                  <ResourcePreview
                    open={open}
                    handleClose={handleClose}
                    styles={states.styles}
                    link={extensionActivity?.config?.linkResource?.key}
                    id={config?.selectedItems[0]?.id}
                    extensionActivity={extensionActivity}
                  />
                )}
              </>
            );
          case balcon:
            return (
              <>
                {open && (
                  <BalconPreview
                    open={open}
                    handleClose={handleClose}
                    selectedItems={extensionActivity?.config?.selectedItems[0]}
                    CHAPTER_ID="33"
                    styles={states.styles}
                    extensionActivity={extensionActivity}
                  />
                )}
              </>
            );

          case conectándome:
            return (
              <>
                {open && (
                  <BalconPreview
                    open={open}
                    handleClose={handleClose}
                    selectedItems={extensionActivity?.config?.selectedItems[0]}
                    CHAPTER_ID="49"
                    styles={states.styles}
                    extensionActivity={extensionActivity}
                  />
                )}
              </>
            );

          case comunidad:
            return (
              <>
                {open && (
                  <BalconPreview
                    open={open}
                    handleClose={handleClose}
                    selectedItems={extensionActivity?.config?.selectedItems[0]}
                    CHAPTER_ID="43"
                    styles={states.styles}
                    extensionActivity={extensionActivity}
                  />
                )}
              </>
            );
          case informate:
            return (
              <>
                {open && (
                  <BalconPreview
                    open={open}
                    handleClose={handleClose}
                    selectedItems={extensionActivity?.config?.selectedItems[0]}
                    CHAPTER_ID="41"
                    styles={states.styles}
                    extensionActivity={extensionActivity}
                  />
                )}
              </>
            );
          case story:
            return (
              <>
                {open && (
                  <StoryPreview
                    open={open}
                    handleClose={handleClose}
                    selectedItems={extensionActivity?.config?.selectedItems[0]}
                    styles={states.styles}
                    level={extensionActivity?.config?.level}
                    extensionActivity={extensionActivity}
                  />
                )}
              </>
            );
          case AP:
            return (
              <>
                {open && (
                  <ApPreview
                    open={open}
                    handleClose={handleClose}
                    selectedItems={extensionActivity?.config?.selectedItems[0]}
                    styles={states.styles}
                    selectedCategoryAP={extensionActivity?.config?.selectedCategoryAP}
                    extensionActivity={extensionActivity}
                    CHAPTER_ID={extensionActivity?.config.selectedCategoryAP?.chapter_ids}
                  />
                )}
              </>
            );

          default:
            return null;
        }
      })()}
    </React.Fragment>
    </div>
  );
};

export default ShowBookPreviewExtensionActivity;
